// Types
import { AlertType } from 'app/modules/alerts/types';

export const ALL_TYPES = [
  AlertType.TM,
  AlertType.CAR,
  AlertType.MANUAL,
  AlertType.KYC,
  AlertType.CHAINALYSIS,
  AlertType.WATCHLIST,
  AlertType.DARK_WEB,
  AlertType.FINCEN_314A,
  AlertType.TRM,
  AlertType.ONBOARDING,
  AlertType.EEL,
];

export const TAB_PATHS = {
  ALERT_UPDATES: 'alert-updates',
  CONSORTIUM_HITS: 'consortium-hits',
  CUSTOM_DATA: 'custom-data',
  TRANSACTION_ANALYSIS: 'txn-analysis',
} as const;

export const TAB_HASHES = {
  ALERT_UPDATES: 'ALERT_UPDATES_TAB',
} as const;
